import React from 'react'
import ControlledSelect, { IControlledSelectProps } from 'transfix-form/components/ControlledSelect'
import { TSelectOpt } from 'transfix-ui/components/Select/SelectTypes'
import { IShipperApplicationStates } from 'types/graphqlTypes'
import { capitalize } from 'utils/capitalize'

const STATUS_OPTIONS = Object.values(IShipperApplicationStates).map(value => ({
  label: capitalize(value),
  value,
}))

const EMPTY_OPTION: TSelectOpt = {
  label: 'Any',
  value: '',
}

interface IControlledStatusSelectProps
  extends Pick<IControlledSelectProps, 'control' | 'onChange'> {}

/**
 * @example
 * ```
 * <ControlledStatusSelect control={control} />
 * ```
 */
const ControlledStatusSelect = ({ control, onChange }: IControlledStatusSelectProps) => {
  return (
    <ControlledSelect
      name='state'
      control={control}
      onChange={onChange}
      SelectProps={{
        label: 'Status',
        options: [EMPTY_OPTION, ...STATUS_OPTIONS],
        placeholder: 'Select a Status',
        dataTest: 'status-input',
      }}
    />
  )
}

export default ControlledStatusSelect
